/**
 * Univerzalni skryvac/odkryvac boxu
 *
 * @param    : (object)   Selektor skryvaneho boxu ve formatu {selector:"#id"[,...]}
 * @param    : (null)     Selektor skryvaneho boxu se zjisti ze spousteciho elementu,
 *                        predpoklada se odkaz na kotvu
 *
 * @return    : (jQuery) object
 *
 **/
define(['jquery'], function ($) {
	"use strict";

	var PLUGIN_NAME = "toggleBox";

	var DEBUG = false;

	var DEFAULTS = {
		preventClick:       true,
		boxActiveClass:     null,
		togglerActiveClass: "active"
	};

	/**
	 *
	 * @param element
	 * @param options
	 * @constructor
	 */
	var ToggleBox = function (element, options) {
		var self = this;
		self.element = element;
		self.$t = $(self.element);

		self._name = PLUGIN_NAME;
		self._defaults = DEFAULTS;

		self.options = $.extend(true, {}, DEFAULTS);

		if (typeof options === 'object') {
			$.extend(true, self.options, options);
		}
		if (typeof options === 'object' && $(options.selector).length > 0) {
			self.options.selector = options.selector;
		}
		else if (typeof options === 'string' && $(options).length > 0) {
			self.options.selector = options;
		}
		else if ($(self.$t.attr('href')).length > 0) {
			self.options.selector = self.$t.attr('href');
		}
		else {
			$.error("Argument error.");
		}

		self.initialise();
	};

	/**
	 * Init function
	 * @private
	 */
	ToggleBox.prototype.initialise = function () {
		var self = this;

		var $area = $(self.options.selector);
		$area.hide();

		self.bindEvents();
	};

	ToggleBox.prototype.bindEvents = function () {
		var self = this;
		var $area = $(self.options.selector);

		self.$t.on("click." + self._name, function (evn) {
			if (self.options.preventClick) evn.preventDefault();
			$area.stop(true, true).slideToggle(function () {
				if (self.options.boxActiveClass != null) $area.toggleClass(self.options.boxActiveClass);
				if (self.options.togglerActiveClass != null) self.$t.toggleClass(self.options.togglerActiveClass);
			});
		});

		if (window.location.hash === self.options.selector) {
			self.$t.trigger("click." + self._name); // otevri vybrany box
			var t = window.setTimeout(function () { // odskroluj na nej
				$("body, html").animate({scrollTop: parseInt(self.$t.offset().top - 10)}, 300);
			}, 700);
		}

	};

	var API = {};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 *        if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 *        if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new ToggleBox(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};

	// simple logger
	function clog(){
		if ( DEBUG && window.console ) {
			for ( var arg in arguments ) {
				console.log( arguments[arg] );
			}
		}
	}

});



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.toggleBox.js